export default "__VITE_ASSET__BDeqO4S6__"